<template>
  <div class="wxcode">
    <p v-if="loading">正在获取用户信息...</p>
    <p v-if="error">{{ error }}</p>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "WxCode", // 组件名同步修改
  data() {
    return {
      loading: false,
      openid: "",
      error: "",
      text: "", // 设备编号
      is_running: "", // 设备是否在使用中
      oaid: "",
    };
  },
  created() {
    // 扫码获取设备编号和项目编号
    //  如果没有扫码，直接进链接的，就使用默认值
    this.text = this.getcode("text") || "861538074490688";
    this.oaid = this.getcode("oaid");
    if (this.oaid) {
      alert(this.oaid);
    }

    if (this.text) {
      localStorage.setItem("text", this.text); // 存储到本地
      this.getOpenId();
    }
  },
  mounted() {},
  methods: {
    async getOpenId() {
      this.loading = true;
      // 检查是否在微信内置浏览器
      if (!this.isWeixinBrowser()) {
        this.error = "请在微信中打开此页面";
        this.loading = false;
        return;
      }
      // 第一步：跳转到微信授权页面
      this.redirectToWechatAuth();
    },

    // 检查是否微信内置浏览器
    isWeixinBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.includes("micromessenger");
    },

    // 获取URL参数
    getcode(name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
      const r = window.location.search.substr(1).match(reg);
      const equ_id_dict = {
        "861683084052886":"861683084053256", // 657:697
        "861683084053462":"861683084053066", // 655:698
        "861683084052969":"861683084051052", // 656:699
        "861683084049999":"861683084053447" // 658:700
      }
      console.log(equ_id_dict);
      if (r != null) {
        if (decodeURIComponent(r[2]) === "861683084052886"){
          // return "861683084053256";
          return "861683084052886";
        }
        else if (decodeURIComponent(r[2]) === "861683084053462"){
          // return "861683084053066";
          return "861683084053462";
        }
        else if (decodeURIComponent(r[2]) === "861683084052969"){
          return "861683084052969";
          // return "861683084051052";
        }
        else if (decodeURIComponent(r[2]) === "861683084049999"){
          return "861683084049999";
          // return "861683084053447";
        }
        else{
          return decodeURIComponent(r[2]);
        }
      }
        return null;
    },

    // 跳转到微信授权页面
    redirectToWechatAuth() {
      const appid = "wxf4658fbb22669c35";
      // 当前页面URL作为回调地址（需要encode）
      const scope = "snsapi_base"; // 静默授权
      // 判断设备有没有在使用中，使用中直接跳转到订单页，否则跳到选择套餐的首页
      this.isDeviceUsed();
      if (this.is_running == 1) {
        this.$router.push({
          path: "/orderList", // 跳到订单列表页面
        });
      } else if (this.is_running == 0) {
        const redirect_uri = `https://zxkj.zxznzy.com/btnList`;
        const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`;
        window.location.href = authUrl;
      }
    },
    // 0 未运行    1 正在运行
    isDeviceUsed() {
      try {
        const res = axios.get(
          "https://htapi.zxznzy.com/project/get_money_list",
          {
            params: { equ_id: localStorage.getItem("text") },
          }
        );
        if (res.data.code === 200) {
          this.is_running = res.data.is_running;
          console.log(this.is_running);
          localStorage.setItem("is_running", res.data.is_running);
        }
      } catch (err) {
        console.error("获取价格列表失败:", err);
      }
    },
  },
};
</script>

<style>
.wxcode {
  background: linear-gradient(45deg, #b5e4f9, #a7cadd);
  color: #333;
  font-size: 18px;
  background-size: cover;
  width: 100%;
  height: 100vh;
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


